import moment from "moment";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";

/**
 * Builds the advanceFilter array from otherCustomStateProperties.
 * Single source of truth for all lead list filters.
 */
export const buildLeadsAdvanceFilter = (
  otherCustomStateProperties: { [key: string]: any },
): IDatatableV2AdvancedSearchFilter => {
  const filters: any[] = [];
  console.log("handleCustomFilterChange 5 ==> ", otherCustomStateProperties)
  // Name or number (combined OR search)
  if (otherCustomStateProperties.searchByNameOrNumber) {
    filters.push({
      column: ["name_of_guest", "contact_number_one"],
      value: otherCustomStateProperties.searchByNameOrNumber,
      logicalOperator: "OR",
      operator: "CONTAINS",
    });
  }

  // Venue
  if (otherCustomStateProperties.searchByVenue) {
    filters.push({
      column: ["preferred_venue"],
      value: otherCustomStateProperties.searchByVenue,
      logicalOperator: "AND",
      operator: "CONTAINS",
    });
  }

  // Function date — month only
  if (
    otherCustomStateProperties.functionMonth &&
    !otherCustomStateProperties.functionYear
  ) {
    filters.push({
      column: ["function_date"],
      value: `-${otherCustomStateProperties.functionMonth}-`,
      logicalOperator: "AND",
      operator: "CONTAINS",
    });
  }

  // Function date — month + year
  if (
    otherCustomStateProperties.functionMonth &&
    otherCustomStateProperties.functionYear
  ) {
    filters.push({
      column: ["function_date"],
      value: `${otherCustomStateProperties.functionYear}-${otherCustomStateProperties.functionMonth}-`,
      logicalOperator: "AND",
      operator: "CONTAINS",
    });
  }

  // Function date — year only (range)
  if (
    otherCustomStateProperties.functionYear &&
    !otherCustomStateProperties.functionMonth
  ) {
    const year = otherCustomStateProperties.functionYear;
    const start = moment(`${year}-01-01`).startOf("year").format("YYYY-MM-DD");
    const end = moment(`${year}-12-31`).endOf("year").format("YYYY-MM-DD");
    filters.push({
      column: ["function_date"],
      value: start,
      logicalOperator: "AND",
      operator: "GREATER_THAN_EQUAL",
    });
    filters.push({
      column: ["function_date"],
      value: end,
      logicalOperator: "AND",
      operator: "LESSER_THAN_EQUAL",
    });
  }

  // Follow-up date (exact)
  if (otherCustomStateProperties.followupDate) {
    filters.push({
      column: ["followup_date"],
      value: otherCustomStateProperties.followupDate,
      logicalOperator: "AND",
      operator: "EQUAL",
    });
    filters.push({
      column: ["actual_status"],
      value: "CANCELLED",
      logicalOperator: "AND",
      operator: "NOT_EQUAL",
    });
  }

  // Function date filter (exact date picker)
  // Guard: skip if functionDate is an object (stale cache from old data shape)
  if (
    otherCustomStateProperties.functionDate &&
    typeof otherCustomStateProperties.functionDate === "string"
  ) {
    filters.push({
      column: ["function_date"],
      value: otherCustomStateProperties.functionDate,
      logicalOperator: "AND",
      operator: "EQUAL",
    });
  }

  // Event type (IN array)
  if (otherCustomStateProperties.searchByEventType?.length > 0) {
    filters.push({
      column: ["event_type"],
      value: otherCustomStateProperties.searchByEventType,
      logicalOperator: "AND",
      operator: "IN",
    });
  }

  // Lead source
  if (otherCustomStateProperties.searchByLeadSource?.lead_source_uuid) {
    filters.push({
      column: ["lead_source_uuid"],
      value: otherCustomStateProperties.searchByLeadSource.lead_source_uuid,
      logicalOperator: "AND",
      operator: "EQUAL",
    });
  }

  // Priority
  if (otherCustomStateProperties.searchByPriority) {
    filters.push({
      column: ["priority"],
      value: otherCustomStateProperties.searchByPriority,
      logicalOperator: "AND",
      operator: "EQUAL",
    });
  }

  // Handled by employee
  if (otherCustomStateProperties.searchByHandledBy?.user_uuid) {
    filters.push({
      column: ["handled_by_employee_uuid"],
      value: otherCustomStateProperties.searchByHandledBy.user_uuid,
      logicalOperator: "AND",
      operator: "EQUAL",
    });
  }

  console.log("handleCustomFilterChange 6 ==> ", filters)
  return filters as IDatatableV2AdvancedSearchFilter;
};
